import { useEffect, useState } from 'react'
import { PulseLoader } from 'react-spinners'
import { useParams } from 'react-router-dom'

import '../styles/geist-font.css'
import '../styles/tokens.css'
import { SessionContextProvider, useSession } from '../contexts/SessionContext'
import { DirectDebitStatusContextProvider } from '../contexts/session/DirectDebitContext'

import Container from '../components/layout/direct-debit/Container'

const SessionPage = () => {
  const { sessionId } = useParams()
  const {
    currentFundingSource,
    sessionData,
    setSessionId,
    loadSessionData,
    setCurrentFundingSource,
  } = useSession()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (sessionId) {
      setSessionId(sessionId)
      loadSessionData(sessionId).finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  // Determine the funding source from session data if not already set
  useEffect(() => {
    if (sessionData && !currentFundingSource)
      setCurrentFundingSource(sessionData.fundingType)
  }, [sessionData, currentFundingSource])

  if (loading) {
    return (
      <div className='d-flex align-items-center justify-content-center vh-100'>
        <PulseLoader size={10} speedMultiplier={0.7} color={'#f7931e'} />
      </div>
    )
  }

  // Only BANK_ACCOUNT_DIRECT_DEBIT is wired up today - Container itself is direct-debit-
  // specific chrome, so an unknown funding source has nothing sensible to render inside it.
  if (currentFundingSource?.toUpperCase() !== 'BANK_ACCOUNT_DIRECT_DEBIT') {
    return (
      <div className='d-flex align-items-center justify-content-center vh-100'>
        Unknown funding source
      </div>
    )
  }

  return <Container />
}

const SessionWrapper = () => {
  return (
    <SessionContextProvider>
      <DirectDebitStatusContextProvider>
        <SessionPage />
      </DirectDebitStatusContextProvider>
    </SessionContextProvider>
  )
}

export default SessionWrapper
